import React from 'react';
import './NotFound.css';

function NotFound() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <span className="notfound-illustration" aria-label="Magnifying glass with sad face">
          {/* Modern SVG illustration: a search glass and a sad face */}
          <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="54" cy="54" r="38" fill="#e0e7ff" stroke="#6366f1" strokeWidth="4" />
            <ellipse cx="54" cy="54" rx="28" ry="28" fill="#fff" />
            <circle cx="46" cy="52" r="4" fill="#6366f1" />
            <circle cx="62" cy="52" r="4" fill="#6366f1" />
            <path d="M46 66c2.5-2 7.5-2 10 0" stroke="#6366f1" strokeWidth="2.5" strokeLinecap="round" />
            <rect x="80" y="80" width="24" height="8" rx="4" fill="#6366f1" transform="rotate(45 80 80)" />
          </svg>
        </span>
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">Oops! We can't find that page.<br/>Let's get you back on track.</p>
        <a className="notfound-home" href="/">Return Home</a>
      </div>
    </div>
  );
}

export default NotFound;
